export interface Country {
  id?: any;
  code: string;
  name: string;
  phonecode: string;
  devise: string;
}

export interface Payment {
  id: string;
  user_id: string | null; // Peut être null pour les paiements sans utilisateur (ex: Moneris Checkout)
  amount_cad: number;
  amount_fcfa: number;
  fee_cad: number;
  conversion_rate: number;
  total_cad: number;
  phone: string;
  operator: string; // ex: "OrangeCameroon"
  provider: string; // ex: "STRIPE"
  status: string; // ex: "FAILED" | "SUCCEEDED" | "REQUIRES_ACTION"
  intent_id: string;
  client_secret: string;
  charge_id: string | null;
  description: string;
  payout_id: string | null;
  payout_order_id: string | null;
  payout_status: string | null;
  payout_amount: number | null;
  payout_currency: string | null;
  payout_method: string | null;
  payout_created_at: string | null;
  payout_updated_at: string | null;
  created_at: string;
  updated_at: string;
  user?: User;
  payout_phonenumber: string;
  payment_type: string;
  payout_name: string;
  sender_country_id?: number | null;
  receiver_country_id?: number | null;
  account_before?: number | null;
  account_after?: number | null;
}

export interface CountryTransfert {
  id?: any;
  country_sender_id: number;
  country_destination_id: number;
  rate: string;
  country_sender?: Country;
  country_destination?: Country;
  created_at?: string;
  updated_at?: string;
}

export interface CountryTransfertItem {
  id?: number;
  country_transfert_id: number;
  name: string;
  url?: string;
  created_at?: string;
  updated_at?: string;
}

export interface CountryTransfertOperator {
  id?: number;
  country_transfert_id: number;
  name: string;
  status: string;
  file?: string;
  file_url?: string;
  created_at?: string;
  updated_at?: string;
}

export interface CountryTransfertBank {
  id?: number;
  country_transfert_id: number;
  code: string;
  bank_name: string;
  status: string;
  file?: string;
  file_url?: string;
  created_at?: string;
  updated_at?: string;
}

export interface CountryTransfertEmail {
  id?: string;
  country_transfert_id: number;
  name: string;
  email: string;
  created_at?: string;
  updated_at?: string;
}

export type CountrySenderStatus = "ACTIVE" | "INACTIVE";

export interface CountrySenderDestination {
  id?: number;
  country_sender_id: number;
  country_destination_id: number;
  status: CountrySenderStatus;
  country_destination?: Country;
  created_at?: string;
  updated_at?: string;
}

export interface CountrySender {
  id?: number;
  country_id: number;
  status: CountrySenderStatus;
  default_daily_limit?: number | null;
  country?: Country;
  destinations?: CountrySenderDestination[];
  created_at?: string;
  updated_at?: string;
}

export interface Concurrent {
  id?: any;
  name: string;
  taxe: string;
}

export interface User {
  id: string;
  country_id: number;
  first_name: string;
  last_name: string;
  email: string;
  phonenumber: string;
  password: string;
  is_verified: "NO" | "YES" | "PENDING" | "REJECTED";
  status: "ACTIVE" | "INACTIVE";
  connexion_type: "EMAIL" | "GOOGLE" | "FACEBOOK";
  role: "USER" | "ADMIN" | "MODERATOR";
  is_deleted: boolean;
  fcm_token: string;
  created_at: string;
  updated_at: string;
  kyc_status?: "ACTIVE" | "INACTIVE" | "NO_KYC";
  interact_email: string;
  has_kyc?: boolean;
  birthdate?: string;
  expired_document_date?: string;
  transaction_stats?: {
    total_sent: number;
    total_sent_cad: number;
    total_sent_currency: string;
    transaction_count: number;
  };
}

export interface Sale {
  id: string;
  id_user_vendeur: string;
  somme_a_vendre: number;
  monaie_vente: string;
  taux_vendeur: number;
  id_pays_vendeur: number;
  id_transaction_vendeur: string | null;
  id_user_acheteur: string | null;
  somme_a_recevoir: number;
  monaie_achat: string;
  id_transaction_acheteur: string | null;
  taux_marchand: number;
  somme_marchand: number;
  status: SaleStatus;
  created_at: string;
  updated_at: string;
}

export type Currency = "XAF" | "CAD" | "USD" | "EUR";

// Pour les statistiques
export interface SaleStats {
  total_amount: number;
  total_sales: number;
  completed_count: number;
  completed_amount: number;
  pending_count: number;
  pending_amount: number;
  cancelled_count: number;
  cancelled_amount: number;
  failed_count: number;
  failed_amount: number;
  unique_sellers: number;
  unique_buyers: number;
}

export enum SaleStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export interface TransactionTracking {
  id?: number;
  transaction_date?: string;
  transaction_time?: string;
  client_name?: string;
  client_contact?: string;
  operation_type?: string;
  expected_amount?: string;
  received_amount?: string;
  payment_method?: string;
  interac_received?: string;
  reference_copied?: string;
  status?: string;
  reason?: string;
  agent?: string;
  action_taken?: string;
  resolution_date?: string;
  observations?: string;
  created_at?: string;
  updated_at?: string;
}
